import { DatePicker, Form, Input, Select } from "antd";
import { IUser } from "../../../types/User";
import type { FormInstance } from "antd/es/form";
import { DateFormat, Genders } from "../../../shared/constants";
import { IDataSource } from "../../../types/DataSource";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import hrnUtils from "../../../utils/hrnUtils";

const ImamBasicInfoForm = ({
    user,
    editForm,
    datasources
}: {
    user: IUser;
    editForm: FormInstance;
    datasources: IDataSource[];
}) => {
    const { t } = useTranslation();
    const requiredRule = { required: true, message: t("Required") };

    return (
        <div>
            <Form.Item name="name" label={<>{t("Name")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Input placeholder={t("Name")} />
            </Form.Item>
            <Form.Item name="loginName" label={<>{t("Login Name")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Input placeholder={t("Login Name")} disabled />
            </Form.Item>
            <Form.Item name="mobileNo" label={<>{t("Mobile No.")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Input type="tel" maxLength={20} onKeyDown={(e) => hrnUtils.handleMobileNumberFieldKeyDownEvent(e)} placeholder={t("Mobile No.")} />
            </Form.Item>
            <Form.Item name="email" label={<>{t("Email")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Input maxLength={30} placeholder={t("Email")} />
            </Form.Item>
            <Form.Item name="gender" label={<>{t("Gender")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Select placeholder={t("Gender")} options={Genders.map((x) => ({ label: t(x), value: x }))} />
            </Form.Item>

            <Form.Item name="dateOfBirth" label={t("Birth date")}>
                <DatePicker placeholder={t("Select date")} className="w-full" format={DateFormat.USUAL} disabledDate={(date: any) => date > dayjs()} onKeyDown={(e: any) => hrnUtils.handleDateFieldKeyDownEvent(e)} />
            </Form.Item>
        </div>
    );
};

export default ImamBasicInfoForm;
